import { isNull } from 'lodash';
import React from 'react';
import './IRAMaxAction.scss';
import config from '../../../../config/config';
import {
  ADD_FUND_MODAL,
  IRA_CONTRIBUTIONS_MODAL,
} from '../../../../redux/modules/modals/modals.module';
import congratsRibbon from '../../../../assets/images/congrats_ribbon.svg';

const IRAMaxAction = ({
  actions: { openModal },
  isSalesforceRep,
  customerWebViewEnabled,
  hasOnlyRetirementFunds,
  IRADataLookUp,
  modalProps,
  quickBuyAgreementId,
  showAllFundsStep,
}) => (
  <div>
    {Object.keys(IRADataLookUp).map((data) => {
      const IRALimitData = IRADataLookUp[data][0];
      const isFullyContributedIRA = IRALimitData.fullyContributedIRA;
      const isMinorIRA = IRALimitData.minorIRAContribution;
      const ownerName = IRALimitData.ownerName;
      return (
        <div key={data}>
          {isFullyContributedIRA && (
            <div className="IRAMax">
              <img src={congratsRibbon} alt="" />
              {isMinorIRA ? (
                <div className="IRAMax-content">
                  <h1 className="IRAMax-header e2e-ira-max-header">
                    {!customerWebViewEnabled && isSalesforceRep ? (
                      <span>
                        <b>Contribution Limit Reached:</b> The maximum annual
                        IRA contribution has been reached for
                        {`${ownerName.split(' ', 1)}`}.
                      </span>
                    ) : (
                      <span>
                        Great job! You’ve reached
                        {`${ownerName.split(' ', 1)}`}'s maximum annual IRA
                        contribution
                      </span>
                    )}
                  </h1>
                  <div className="IRAMax-content">
                    View
                    <a
                      className="IRAMax-modal"
                      onClick={() =>
                        openModal(IRA_CONTRIBUTIONS_MODAL, { IRALimitData })
                      }
                    >
                      {' '}
                      IRA contribution details
                    </a>{' '}
                    for more info.
                  </div>
                </div>
              ) : (
                <div className="IRAMax-content">
                  <h1 className="IRAMax-header e2e-ira-max-header">
                    {!customerWebViewEnabled && isSalesforceRep ? (
                      <span>
                        <b>Contribution Limit Reached:</b> The maximum annual
                        IRA contribution has been reached.
                      </span>
                    ) : (
                      <span>
                        Great job! You’ve reached the maximum annual IRA
                        contribution
                      </span>
                    )}
                  </h1>
                  <div className="IRAMax-content hidden-xs">
                    You can still invest in existing non-retirement accounts,
                    {hasOnlyRetirementFunds ? (
                      <a
                        className="IRAMax-modal"
                        href={`${config.rmlUrl}/usis/nasu/account-finder`}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        add a new fund
                      </a>
                    ) : isNull(quickBuyAgreementId) ||
                      showAllFundsStep === true ? (
                      <a
                        className="IRAMax-modal"
                        onClick={() => openModal(ADD_FUND_MODAL, modalProps)}
                      >
                        add a new fund
                      </a>
                    ) : (
                      ' add a new fund '
                    )}
                    to your portfolio, or view your
                    <a
                      className="IRAMax-modal"
                      onClick={() =>
                        openModal(IRA_CONTRIBUTIONS_MODAL, { IRALimitData })
                      }
                    >
                      IRA contribution details
                    </a>
                    for more info.
                  </div>
                  <div className="IRAMax-content-xs visible-xs">
                    <a
                      onClick={() =>
                        openModal(IRA_CONTRIBUTIONS_MODAL, { IRALimitData })
                      }
                    >
                      View IRA contribution details
                    </a>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      );
    })}
  </div>
);

export default IRAMaxAction;
